// removed by extract-text-webpack-plugin
module.exports = {"inputContainer":"styles__inputContainer___1KHWW","input":"styles__input___3EVcH","label":"styles__label___3n9c8","checkmark":"styles__checkmark___3U9kw","containerIcon":"styles__containerIcon___2w1AY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputCheckbox/styles.css
// module id = 2801
// module chunks = 0